/**
 * Resolves the average a card shows its stars for, or nothing where the product is
 * unrated.
 *
 * Gated on the average being above zero rather than on it being present. Zero means
 * unrated rather than rated zero, since there is no zero star review to leave, and
 * passing it would draw an empty star row where the card shows "NEW" instead.
 *
 * A review count is deliberately not part of this: the card shows the average alone.
 */
export const toProductCardRating = (averageRating: number | null | undefined) =>
  typeof averageRating === 'number' && Number.isFinite(averageRating) && averageRating > 0
    ? averageRating
    : undefined;
